import * as React from 'react';
import { useCookieConsentContext, isCookieCategoryEnabled } from '@grandvisionhq/cookie-consent';
import { TealiumService } from './service.js';

const TealiumContext = /*#__PURE__*/ React.createContext(null);
TealiumContext.displayName = 'TealiumContext';
const TealiumProvider = (props)=>{
    const { enableCookieCheck , sdkUrl , children  } = props;
    const consentResult = useCookieConsentContext();
    const consentGranted = isCookieCategoryEnabled('analytics', consentResult);
    /**
   * Based on EL request we have the option to disable cookie checks: CXIB-1359
   *
   * In all cases if sdkUrl is not provided, Tealium will not be loaded.
   *
   * Tealium behavior based on cookie check:
   * - Tealium disabled regardless of cookie check:
   *   ref.current = undefined
   * - Old situation with checking cookie first:
   *   enableCookieCheck = true
   *   consentGranted = true
   * - Tealium enabled without checking for cookie consent:
   *   enableCookieCheck = false / undefined
   *   consentGranted = false / undefined
   */ const shouldTealiumLoad = enableCookieCheck ? consentGranted : true;
    const ref1 = React.useRef(TealiumService.createInstance(sdkUrl));
    React.useEffect(()=>{
        var ref;
        const cleanup = (ref = ref1.current) === null || ref === void 0 ? void 0 : ref.listen();
        return cleanup;
    }, []);
    React.useEffect(()=>{
        if (shouldTealiumLoad) {
            const service = ref1.current;
            service === null || service === void 0 ? void 0 : service.load();
            return ()=>{
                service === null || service === void 0 ? void 0 : service.teardown();
            };
        }
    }, [
        shouldTealiumLoad
    ]);
    return /*#__PURE__*/ React.createElement(TealiumContext.Provider, {
        value: null
    }, children);
};

export { TealiumProvider };
//# sourceMappingURL=provider.js.map
